import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RaAccountingStatusPicker } from '../../../../components/entity-picker/ra-accounting-status-picker/RaAccountingStatusPicker';
import { FilterCard } from '../filter-card/FilterCard';

type Props = {
  title: string;
  value: { id: string; name: string }[] | null;
  onChange: (value: { id: string; name: string }[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
};

export const RaAccountingStatusFilterCard: React.FC<Props> = (props) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    if (value.length === 1) return t(`RA.ACCOUNTING_STATUSES.${value[0].id}`);
    return `${value.length} ${t('COMMON.CHOSEN')}`;
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <RaAccountingStatusPicker
        multiple={true}
        value={value}
        onChange={onChange}
      />
    </FilterCard>
  );
};
